<template>
    <div :class="styleMain">
      <el-switch v-model="owngoal" />
      <div class="title">CSC</div>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionOwngoal',
  props: {
    action: Object
  },
  computed: {
    owngoal: {
      get () { return this.action.owngoal },
      set (value) {
        const data = { id: this.action.id, owngoal: value, personId: null, person2Id: null }
        this.$store.dispatch('Sport/Football/Match/putAction', data)
      }
    },

    styleMain () { return ['sportFootballMatchActionOwngoal', this.action.homeAway] }
  }
}
</script>

<style>
.sportFootballMatchActionOwngoal {
  grid-area: owngoal;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.sportFootballMatchActionOwngoal > div{
  flex:1
}
.sportFootballMatchActionOwngoal > div.title{
  font-size:8px;
  margin-top:5px;
  z-index:1
}
.sportFootballMatchActionOwngoal.home .el-switch.is-checked .el-switch__core{
  border-color:var(--color-team-home);
  background-color:var(--color-team-home)
}
.sportFootballMatchActionOwngoal.away .el-switch.is-checked .el-switch__core{
  border-color:var(--color-team-away);
  background-color:var(--color-team-away)
}
</style>
